'use client'

import type { ReactNode } from 'react'
import Link from 'next/link'

import { Button } from '@indxsearch/systm'
import { Feather } from '@indxsearch/pixl'
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Pixl from '@/components/mdx/Pixl'
import type { ArticleMeta } from '@/lib/articles'
import styles from './article.module.css'

export default function ArticleView({
  article,
  more,
  children,
}: {
  article: ArticleMeta
  more: ArticleMeta[]
  children: ReactNode
}) {
  return (
    <div style={{ maxWidth: 'var(--MaxWidth)', margin: '0 auto' }}>
      <Nav />
      <main className={styles.main}>
        <article className={styles.article}>
          <div className={styles.backlink}>
            <Button size="micro" variant="ghost" iconLeft={<Feather />} href="/articles">
              Articles
            </Button>
          </div>
          <h1 className={styles.title}>{article.title}</h1>
          <p className={styles.lead}>{article.description}</p>
          <div className={styles.meta}>
            {article.icon && <Pixl name={article.icon} className={styles.metaIcon} />}
            <span>{article.category === 'guide' ? 'Guide' : 'Update'}</span>
          </div>
          <div className={styles.prose}>{children}</div>

          {more.length > 0 && (
            <section className={styles.more}>
              <h2 className={styles.moreTitle}>More articles</h2>
              <div className={styles.moreList}>
                {more.map((a) => (
                  <Link key={a.slug} href={`/articles/${a.slug}`} className={styles.moreItem}>
                    {a.icon && (
                      <span className={styles.moreIconBox}>
                        <Pixl name={a.icon} />
                      </span>
                    )}
                    <div className={styles.moreItemBody}>
                      <div className={styles.moreItemTitle}>{a.title}</div>
                      <p className={styles.moreItemDesc}>{a.description}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          )}
        </article>
      </main>
      <Footer />
    </div>
  )
}
